
<script>
import StudentCompletion from '../components/Reports/StudentCompletion'
export default {
  name: 'Reports',
  components: {
    StudentCompletion
  },
  data () {
    return {
      module: this.$route.meta.module
    }
  }
}
</script>
<template>
  <q-page padding>
    <!-- content -->
    <student-completion :open="true"/>
  </q-page>
</template>

<style>
</style>
